import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/ModelSelect.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable no-undefined */
import React, { useMemo } from 'react';
import { combine } from 'effector';
import { useStore, useStoreMap } from 'effector-react';
import { ListItemText, ListItemSecondaryAction, List } from '@mui/material';
import styled from 'styled-components';
import { Box } from '@gmini/ui-kit/lib/Box';
import { Checkbox } from '@gmini/ui-kit/lib/Checkbox';
import { isNotEmpty } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { CubeWithTarget, Tooltip } from '@gmini/ui-kit';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { adapter } from "../../classifier-service/adapters";
import { getClassifierIcon } from "../../classifier-editor/Common";
import { NumCircle } from "../../components";
import { multiplyViewerSelect$ } from "../../forge-viewer/model/selectModel";
import { loadedModels$ } from "../../forge-viewer/model/loadedModel";
import { checkedAndNotLoaded$ } from "../FromTreeToViewer";
import { buildIdVersionKey } from "../DependencyTree/model";
import { sortDependencyWithModelsBySourceClassifiers } from "../../helpers";
import { IconWrap, ListItemTextNoWrap, CubeWithTargetWrapper, ListItemSelect, ArrowDownWrapper, ArrowDown, ListItem, Popover } from "./ModelSelect.styled";
import { SelectItem } from "./SelectItem";
import { selectedModels } from "./selectedModels";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var useModelExists = function useModelExists(selectedElements, dependenciesWithModels$, getViewerId) {
  return useStoreMap({
    store: dependenciesWithModels$,
    keys: [selectedElements],
    //TODO убрать вложенные циклы
    fn: function fn(dependenciesWithModels, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          selectedElements = _ref2[0];

      return !!dependenciesWithModels.filter(function (classifier) {
        return classifier.models.length ? classifier.models.find(function (model) {
          var _model$viewerRefs;

          return (_model$viewerRefs = model.viewerRefs) === null || _model$viewerRefs === void 0 ? void 0 : _model$viewerRefs.some(function (viewerRef) {
            if (!(selectedElements !== null && selectedElements !== void 0 && selectedElements.length)) {
              return false;
            }

            return selectedElements.some(function (selectedElement) {
              var _selectedElement$view;

              return selectedElement === null || selectedElement === void 0 ? void 0 : (_selectedElement$view = selectedElement.viewerRefs) === null || _selectedElement$view === void 0 ? void 0 : _selectedElement$view.some(function (selectedViewerRef) {
                return getViewerId(selectedElement, selectedViewerRef) === getViewerId(adapter(model), viewerRef);
              });
            });
          });
        }) : null;
      }).filter(isNotEmpty).length;
    }
  });
};

var pending$ = combine({
  ɔ: [[api.DependencyWithModels.getClassifierDependencyModels.defaultContext.pending$, api.DependencyWithModels.getAssemblyDependencyModels.defaultContext.pending$], function (pendingList) {
    return pendingList.some(Boolean);
  }],
  config: {
    name: "pending$",
    sid: "-1wtlca"
  }
});
export var ModelSelect = function ModelSelect(_ref3) {
  var dependencyRootNodes$ = _ref3.dependencyRootNodes$,
      currentEntity$ = _ref3.currentEntity$,
      searchedBimNodes$ = _ref3.searchedBimNodes$,
      getViewerId = _ref3.getViewerId,
      modelStoreService = _ref3.modelStoreService;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var checkedAndNotLoaded = useStore(checkedAndNotLoaded$, {
    loc: {
      file: _effectorFileName,
      line: 136,
      column: 30
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [136, 30]"
  });
  var multiplyViewerSelect = useStore(multiplyViewerSelect$, {
    loc: {
      file: _effectorFileName,
      line: 138,
      column: 31
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [138, 31]"
  });
  var loadedViewerModels = useStore(loadedModels$, {
    loc: {
      file: _effectorFileName,
      line: 140,
      column: 29
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [140, 29]"
  });
  var checkedUrns = (multiplyViewerSelect === null || multiplyViewerSelect === void 0 ? void 0 : multiplyViewerSelect.map(function (select) {
    return select.viewerId;
  })) || [];
  var classes = useStyles();
  var dependenciesList = useStore(dependencyRootNodes$, {
    loc: {
      file: _effectorFileName,
      line: 146,
      column: 27
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [146, 27]"
  });
  var selectedModelsMap = useStore(modelStoreService.selectedModel$, {
    loc: {
      file: _effectorFileName,
      line: 147,
      column: 28
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [147, 28]"
  });
  var selectedElements = useStore(searchedBimNodes$, {
    loc: {
      file: _effectorFileName,
      line: 148,
      column: 27
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [148, 27]"
  });
  var modelExists = useModelExists(selectedElements, modelStoreService.dependenciesWithModels$, getViewerId);
  var classifiersWithModels = useStore(modelStoreService.dependenciesWithModels$, {
    loc: {
      file: _effectorFileName,
      line: 154,
      column: 32
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [154, 32]"
  });
  var currentEntity = useStore(currentEntity$, {
    loc: {
      file: _effectorFileName,
      line: 158,
      column: 24
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [158, 24]"
  });
  var sortedDependenciesWithModels = useMemo(function () {
    return sortDependencyWithModelsBySourceClassifiers(currentEntity, classifiersWithModels);
  }, [classifiersWithModels, currentEntity]);
  var modelIsLoading = React.useCallback(function (urn) {
    return loadedViewerModels[urn] && loadedViewerModels[urn] !== 'Finished';
  }, [loadedViewerModels]);
  var pending = useStore(pending$, {
    loc: {
      file: _effectorFileName,
      line: 175,
      column: 18
    },
    name: "ModelSelect",
    sid: "ModelSelect /src/classifier-editor/ModelSelect/ModelSelect.tsx [175, 18]"
  });
  var disabled = React.useMemo(function () {
    return !(sortedDependenciesWithModels !== null && sortedDependenciesWithModels !== void 0 && sortedDependenciesWithModels.length) || (sortedDependenciesWithModels === null || sortedDependenciesWithModels === void 0 ? void 0 : sortedDependenciesWithModels.every(function (_ref4) {
      var models = _ref4.models;
      return !models.length;
    }));
  }, [sortedDependenciesWithModels]);

  var handleChange = function handleChange(checked, model, baseClassifierId) {
    var viewerRefs = model.viewerRefs;

    if (!viewerRefs) {
      return;
    }

    if (checked) {
      viewerRefs.forEach(function (viewerRef) {
        selectedModels.addModel({
          viewerId: getViewerId(model, viewerRef),
          baseClassifierId: baseClassifierId,
          modelId: model.id,
          modelVersion: model.version
        });
      });
    } else {
      viewerRefs.forEach(function (viewerRef) {
        selectedModels.replaceModel({
          viewerId: getViewerId(model, viewerRef),
          baseClassifierId: baseClassifierId,
          modelId: model.id,
          modelVersion: model.version
        });
      });
    }
  }; //TODO убрать вложенные циклы


  var modelIsLoaded = !!(selectedElements !== null && selectedElements !== void 0 && selectedElements.every(function (_ref5) {
    var viewerRefs = _ref5.viewerRefs;
    return viewerRefs === null || viewerRefs === void 0 ? void 0 : viewerRefs.every(function (selectedViewerRef) {
      return selectedModelsMap && Object.values(selectedModelsMap).some(function (model) {
        return selectedElements.some(function (selectedElement) {
          var _model$viewerRefs2;

          return (_model$viewerRefs2 = model.viewerRefs) === null || _model$viewerRefs2 === void 0 ? void 0 : _model$viewerRefs2.some(function (viewerRef) {
            return getViewerId(adapter(model), viewerRef) === getViewerId(selectedElement, selectedViewerRef);
          });
        });
      });
    });
  }));
  var highlightModelList = modelExists && !modelIsLoaded || checkedAndNotLoaded; //TODO убрать вложенные циклы

  var isModelElementSelected = function isModelElementSelected(model) {
    var hasSearchedElements = !!(selectedElements !== null && selectedElements !== void 0 && selectedElements.some(function (selectedElement) {
      var _selectedElement$view2;

      return selectedElement === null || selectedElement === void 0 ? void 0 : (_selectedElement$view2 = selectedElement.viewerRefs) === null || _selectedElement$view2 === void 0 ? void 0 : _selectedElement$view2.some(function (selectedViewerRef) {
        var _model$viewerRefs3;

        return (_model$viewerRefs3 = model.viewerRefs) === null || _model$viewerRefs3 === void 0 ? void 0 : _model$viewerRefs3.some(function (viewerRef) {
          return getViewerId(model, viewerRef) === getViewerId(selectedElement, selectedViewerRef);
        });
      });
    }));
    var hasCheckedElements = !!(checkedUrns !== null && checkedUrns !== void 0 && checkedUrns.length && checkedUrns.some(function (viewerId) {
      var _model$viewerRefs4;

      return (_model$viewerRefs4 = model.viewerRefs) === null || _model$viewerRefs4 === void 0 ? void 0 : _model$viewerRefs4.some(function (viewerRef) {
        return viewerId === getViewerId(model, viewerRef);
      });
    }));
    return hasSearchedElements || hasCheckedElements;
  };

  var isModelChecked = function isModelChecked(_ref6) {
    var id = _ref6.id,
        version = _ref6.version;
    return !!(selectedModelsMap && selectedModelsMap[buildIdVersionKey({
      id: id,
      version: version
    })]);
  };

  var selectLabel = 'Не выбрано';
  var selectedModelValues = useMemo(function () {
    return Object.values(selectedModelsMap || {});
  }, [selectedModelsMap]);
  var allAvailableModelsCount = useMemo(function () {
    return sortedDependenciesWithModels === null || sortedDependenciesWithModels === void 0 ? void 0 : sortedDependenciesWithModels.reduce(function (acc, _ref7) {
      var models = _ref7.models;
      return acc + models.length;
    }, 0);
  }, [sortedDependenciesWithModels]);

  if (selectedModelValues.length === 1) {
    selectLabel = selectedModelValues[0].name;
  }

  if (selectedModelValues.length > 1) {
    selectLabel = "\u0412\u044B\u0431\u0440\u0430\u043D\u043E ".concat(selectedModelValues.length, "/").concat(allAvailableModelsCount, " \u043C\u043E\u0434\u0435\u043B\u0435\u0439");
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      border: 2,
      ml: "2px",
      borderRadius: "4px",
      borderColor: "transparent",
      children: /*#__PURE__*/_jsx(List, {
        className: classes.list,
        component: "nav",
        dense: true,
        disablePadding: true,
        onClick: handleClick,
        "data-test-id": "selectModel",
        children: /*#__PURE__*/_jsx(Tooltip, {
          placement: "top",
          title: (selectedModelsMap === null || selectedModelsMap === void 0 ? void 0 : selectedModelsMap.name) || '',
          children: /*#__PURE__*/_jsxs(ListItem, {
            disabled: disabled,
            dense: true,
            "aria-haspopup": "true",
            "aria-controls": "lock-menu",
            selected: Boolean(anchorEl),
            children: [/*#__PURE__*/_jsx(ListItemTextNoWrap, {
              primary: selectLabel
            }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
              children: /*#__PURE__*/_jsx(ArrowDownWrapper, {
                disabled: pending || disabled,
                onClick: handleClick,
                highlight: highlightModelList,
                selected: Boolean(anchorEl),
                children: /*#__PURE__*/_jsx(ArrowDown, {
                  selected: Boolean(anchorEl)
                })
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx(Popover, {
      open: open,
      anchorEl: anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      children: /*#__PURE__*/_jsx(PopoverContentBox, {
        children: /*#__PURE__*/_jsx(List, {
          dense: true,
          disablePadding: true,
          children: sortedDependenciesWithModels === null || sortedDependenciesWithModels === void 0 ? void 0 : sortedDependenciesWithModels.map(function (data) {
            return _objectSpread(_objectSpread({}, data), {}, {
              models: data.models.map(adapter)
            });
          }).map(function (_ref8) {
            var models = _ref8.models,
                classifier = _ref8.classifier;
            var dependencyDisplayIdx = "".concat(dependenciesList.findIndex(function (dependency) {
              return dependency.type === 'BimModelReferenceNode' ? dependency.parentClassifierId === classifier.id : dependency.id === classifier.id;
            }) + 1);

            if (api.BaseClassifier.is(classifier)) {
              var _model$viewerRefs5;

              var model = models[0];
              return model && /*#__PURE__*/_jsx(SelectItem, {
                checked: isModelChecked(model),
                onChange: function onChange(checked) {
                  return handleChange(checked, model, classifier.id);
                },
                modelElementSelected: isModelElementSelected(model),
                modelPending: !!((_model$viewerRefs5 = model.viewerRefs) !== null && _model$viewerRefs5 !== void 0 && _model$viewerRefs5.some(function (viewerRef) {
                  return modelIsLoading(getViewerId(model, viewerRef));
                })),
                dependencyIdx: dependencyDisplayIdx,
                children: model.name
              }, model.id);
            }

            if (api.AssemblyClassifier.is(classifier)) {
              var isSelectedAllChecked = models.every(function (model) {
                return isModelChecked(model);
              });
              var isLoadingModel = models.some(function (model) {
                var _model$viewerRefs6;

                return (_model$viewerRefs6 = model.viewerRefs) === null || _model$viewerRefs6 === void 0 ? void 0 : _model$viewerRefs6.some(function (viewerRef) {
                  return modelIsLoading(getViewerId(model, viewerRef));
                });
              });
              return /*#__PURE__*/_jsxs(React.Fragment, {
                children: [/*#__PURE__*/_jsxs(ListItemSelect, {
                  onChange: function onChange() {
                    if (isLoadingModel) {
                      return;
                    }

                    models.forEach(function (model) {
                      handleChange(!isSelectedAllChecked, model, classifier.id);
                    });
                  },
                  disabled: isLoadingModel,
                  children: [/*#__PURE__*/_jsx(Checkbox, {
                    checked: isSelectedAllChecked
                  }), /*#__PURE__*/_jsx(CubeWithTargetWrapper, {
                    children: /*#__PURE__*/_jsx(CubeWithTarget, {})
                  }), /*#__PURE__*/_jsx(ListItemText, {
                    primary: classifier.name
                  }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
                    children: /*#__PURE__*/_jsx(NumCircle, {
                      disabled: true,
                      children: dependencyDisplayIdx
                    })
                  })]
                }), /*#__PURE__*/_jsx(List, {
                  dense: true,
                  disablePadding: true,
                  children: models.map(function (model, i) {
                    var _model$viewerRefs7;

                    return /*#__PURE__*/_jsx(SelectItem, {
                      isChild: true,
                      checked: isModelChecked(model),
                      onChange: function onChange(checked) {
                        return handleChange(checked, model, classifier.id);
                      },
                      modelElementSelected: isModelElementSelected(model),
                      modelPending: !!((_model$viewerRefs7 = model.viewerRefs) !== null && _model$viewerRefs7 !== void 0 && _model$viewerRefs7.some(function (viewerRef) {
                        return modelIsLoading(getViewerId(model, viewerRef));
                      })),
                      dependencyIdx: "".concat(dependencyDisplayIdx, ".").concat(i + 1),
                      children: model.name
                    }, model.id);
                  })
                })]
              }, classifier.id);
            }

            return /*#__PURE__*/_jsxs(React.Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: classes.selectItem,
                children: [/*#__PURE__*/_jsx(IconWrap, {
                  children: getClassifierIcon(adapter(classifier))
                }), /*#__PURE__*/_jsx(ListItemText, {
                  primary: classifier.name
                }), /*#__PURE__*/_jsx(ListItemSecondaryAction, {
                  children: /*#__PURE__*/_jsx(NumCircle, {
                    disabled: true,
                    children: dependencyDisplayIdx
                  })
                })]
              }), /*#__PURE__*/_jsx(List, {
                dense: true,
                disablePadding: true,
                children: models.map(function (model, i) {
                  var _model$viewerRefs8;

                  return /*#__PURE__*/_jsx(SelectItem, {
                    isChild: true,
                    checked: isModelChecked(model),
                    onChange: function onChange(checked) {
                      return handleChange(checked, model, classifier.id);
                    },
                    modelElementSelected: isModelElementSelected(model),
                    modelPending: !!((_model$viewerRefs8 = model.viewerRefs) !== null && _model$viewerRefs8 !== void 0 && _model$viewerRefs8.some(function (viewerRef) {
                      return modelIsLoading(getViewerId(model, viewerRef));
                    })),
                    dependencyIdx: "".concat(dependencyDisplayIdx, ".").concat(i + 1),
                    children: model.name
                  }, model.id);
                })
              })]
            }, classifier.id);
          })
        })
      })
    })]
  });
};
var useStyles = makeStyles(function () {
  return createStyles({
    list: {
      '& .MuiListItem-secondaryAction': {
        paddingRight: '34px',
        paddingLeft: '12px'
      },
      '& .MuiListItemSecondaryAction-root': {
        right: '4px'
      }
    },
    selectItem: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      padding: '8px 48px 8px 15px',
      '& .MuiListItemSecondaryAction-root': {
        right: '12px'
      }
    }
  });
}); //https://github.com/microsoft/TypeScript/issues/42873

var PopoverContentBox = styled(Box)({
  minWidth: '269px'
});